import MetaInfoListItem from "components/MetaInfoList/Item";
import { WorkerPool } from "types/generated";
import { withoutPublicWorkerPool } from "utils/distribution";
import {
  PUBLIC_WORKER_POOL_NAME,
  PUBLIC_WORKER_POOL_URL,
} from "views/Account/WorkerPool/constants";

const noPublicWorkerPool = withoutPublicWorkerPool();

type WorkerPoolMetaInfoItemProps = {
  workerPool: Pick<WorkerPool, "id" | "name"> | null;
};

const WorkerPoolMetaInfoItem = ({ workerPool }: WorkerPoolMetaInfoItemProps) => {
  return (
    <>
      {workerPool && (
        <MetaInfoListItem linkText={workerPool.name} to={`/worker-pool/${workerPool.id}`} />
      )}
      {!workerPool && !noPublicWorkerPool && (
        <MetaInfoListItem linkText={PUBLIC_WORKER_POOL_NAME} to={PUBLIC_WORKER_POOL_URL} />
      )}
      {!workerPool && noPublicWorkerPool && <MetaInfoListItem>&mdash;</MetaInfoListItem>}
    </>
  );
};

export default WorkerPoolMetaInfoItem;
